module.exports = __webpack_public_path__ + "img/8377e17.jpg";